import { constructIds } from "../../config/common";

export const newIndexForCopiedItem = (itemsArray) => {
    let resArray = [];
    const nameArray = itemsArray.map(item => item.name);

    nameArray.map(itemname => {
        var index = itemname.lastIndexOf("_");
        if (index >= 0) {
            const result = itemname.substr(index + 1);
            if (result.includes('copy')) {
                var matches = result.match(/(\d+)/)[0];
                const lastIndex = parseInt(matches)
                resArray.push(lastIndex)
            }

        }

    })

    let largestIndex = 0;
    if (resArray.length > 0) {
        largestIndex = resArray.reduce(function (accumulatedValue, currentValue) {
            return Math.max(accumulatedValue, currentValue);
        });
    }

    return largestIndex
}

const getNodeData = (transactionNodes, dependId) => {

    const nodeData = transactionNodes.find(trNode => trNode.id === dependId);
    // console.log(nodeData)
    if (nodeData !== undefined) return nodeData
}

export const validateTransactionNodes = (clickedNodes, transactionNodes, connections) => {

    const linkedNodes = [];

    // console.log('INCOMING DATA----->', { clickedNodes, transactionNodes, connections })

    clickedNodes.forEach(clickedNode => {
        connections?.forEach(con => {
            let dependNode = '';
            if (con.source === clickedNode.id) {
                dependNode = getNodeData(transactionNodes, con.target)
            }

            else if (con.target === clickedNode.id) {
                dependNode = getNodeData(transactionNodes, con.source)
            }

            // console.log("DEPEND-------->", dependNode)

            const isExist = linkedNodes?.filter(linkedNode => {
                if (dependNode !== undefined && linkedNode?.id === dependNode?.id && dependNode !== '') return linkedNode
            });

            if (isExist.length === 0) linkedNodes.push(dependNode)

            const isSelectedNodeExist = linkedNodes?.filter(linkedNode => {
                if (linkedNode !== undefined && linkedNode.id === clickedNode?.id) return linkedNode
            })

            if (isSelectedNodeExist.length === 0) linkedNodes.push(clickedNode)
        })

    })

    // console.log('DATA---->', linkedNodes)
    return linkedNodes;
}


export const validateTransactionNodesForEdit = (clickedNodes, transactionNodes, connections) => {

    const linkedNodes = [];

    clickedNodes.forEach(clickedNode => {

        connections.forEach(con => {

            let dependNode = '';
            if (con.source === clickedNode.id || con.target == clickedNode.id) {

                if (clickedNode.category == 'userdefined') {
                    dependNode = getNodeData(transactionNodes, con.target)
                } else {
                    dependNode = getNodeData(transactionNodes, con.target)
                }

                const isExist = linkedNodes.find(linkedNode => linkedNode?.id === dependNode?.id)
                if (isExist === undefined && dependNode !== '') {
                    // console.log({ dependNode })
                    linkedNodes.push(dependNode)
                }
            }



            // const isSelectedNodeExist = linkedNodes.filter(linkedNode => linkedNode.id === clickedNode.id)
            // if (isSelectedNodeExist.length === 0) linkedNodes.push(clickedNode)

        })

    })

    return linkedNodes;
}

export const getDuplicates = (constructs) => {
    // console.log("constructs------>", constructs)

    var contructWithDuplications = {}

    for (const construct in constructs) {

        let resArray = [];
        let loopingAray = [];

        if (construct !== 'utility_functions') {
            const resConstructs = constructs[construct].map((item) => {
                if (loopingAray.some((val) => { return val.id == item.id })) {

                    if ((loopingAray.filter(existItem => existItem.id == item.id)).length == 1) {
                        loopingAray.push(item)
                        resArray.push(item)
                    }

                }
                else {
                    let tempObj = {}
                    tempObj = item
                    loopingAray.push(tempObj);
                }
            })
            if (resArray.length > 0) {
                contructWithDuplications[construct] = resArray
            }
        }
        // else {
        //     contructWithDuplications[construct] = constructs[construct]
        // }



    }

    //console.log("resss---->", contructWithDuplications)
    return contructWithDuplications

}

export const checkParentId = (constructs) => {


    const allConstructs = constructs;

    for (const construct in allConstructs) {

        if (construct == 'fields' || construct == 'sections') {

            allConstructs[construct].forEach((item) => {

                if (item.parent !== undefined && item.parent.length > 0) {
                    if (typeof (item?.parent[0]?.type) == "number") {
                        item.parent[0].type = (constructIds.find(c => c.id == item?.parent[0]?.type))?.type
                    }
                }
            })

        }





    }

    //console.log("resss---->", contructWithDuplications)
    return allConstructs

}


export const removeDuplicates = (constructs, duplicates) => {

    // console.log('constructs, duplicates', { constructs, duplicates })
    var contructWithOutDuplications = {}


    for (const construct in constructs) {
        const arr = [];
        if (construct !== 'utility_functions') {
            constructs[construct].map(con => {
                if (duplicates[construct] !== undefined && duplicates[construct].length > 0) {
                    const dupElement = duplicates[construct].find(dup => dup.id == con.id);
                    if (dupElement !== undefined) {
                        const alredyExist = arr.find(ar => ar.id == con.id);
                        if (alredyExist === undefined) {
                            arr.push(con)
                        }
                    }
                    else {
                        arr.push(con)
                    }
                }
                else {
                    arr.push(con)
                }
            })
            contructWithOutDuplications[construct] = arr;
        }
        else {
            contructWithOutDuplications[construct] = constructs[construct];
        }

    }

    // for (const duplicate in duplicates) {
    //     for (const construct in constructs) {

    //         if (duplicate !== construct) {
    //             // contructWithOutDuplications[construct] = constructs[construct];
    //         }
    //         else {
    //             const arr = [];
    //             constructs[construct].map(con => {
    //                 const dupElement = duplicates[duplicate].find(dup => dup.id == con.id);
    //                 if (dupElement !== undefined) {
    //                     const alredyExist = arr.find(ar => ar.id == con.id);
    //                     if (alredyExist === undefined) {
    //                         arr.push(con)
    //                     }
    //                 }
    //                 else {
    //                     arr.push(con)
    //                 }
    //             })
    //             contructWithOutDuplications[construct] = arr;
    //         }

    //     }
    // }

    // console.log('contructWithOutDuplications---', contructWithOutDuplications)
    return contructWithOutDuplications
}


export const checkDuplicateNonEmpty = (duplicates) => {

    if (Object.keys(duplicates).length == 0) {
        return false;
    }

    else {
        for (var dup in duplicates) {
            if (duplicates[dup].length > 0) {
                return true;
            }
        }
    }
    return false


}

function descendingComparator(a, b, orderBy) {

    // if (b[orderBy] < a[orderBy]) {
    //     return -1;
    // }
    // if (b[orderBy] > a[orderBy]) {
    //     return 1;
    // }

    if (getValueByDottedKeys(b, orderBy) < getValueByDottedKeys(a, orderBy)) {
        return -1;
    }
    if (getValueByDottedKeys(b, orderBy) > getValueByDottedKeys(a, orderBy)) {
        return 1;
    }


    return 0;
}

export function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const getValueByDottedKeys = (obj, strKey) => {
    let keys = strKey.split(".")
    let value = obj[keys[0]];
    for (let i = 1; i < keys.length; i++) {
        value = value[keys[i]]
    }
    return value
}

export const findNearestValues = (arr, num) => {
    const greaterValues = arr.filter(obj => obj.positionY > num);
    const smallerValues = arr.filter(obj => obj.positionY < num);

    const nearestGreater = greaterValues.length > 0 ?
        greaterValues.reduce((a, b) => a.positionY < b.positionY ? a : b) : { positionY: 12000 };

    const nearestSmaller = smallerValues.length > 0 ?
        smallerValues.reduce((a, b) => a.positionY > b.positionY ? a : b) : { positionY: 0 };

    return { nearestGreater, nearestSmaller };
}

export function arraysEqual(arr1, arr2) {
    // Check if the arrays are the same length
    if (arr1.length !== arr2.length) {
        return false;
    }

    // Check if each element is the same
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }

    // If we haven't returned yet, the arrays are the same
    return true;
}

// Checking same name exist in digitalTwin and analytics
export const doesSameNameDigitalTwinAndAnalytics = (name, clusterlets) => {
    let status = true;
    status = clusterlets.find(clusterlet => {
        return clusterlet.name == name;
    });

    return status == null ? true : false;
}

export const getMessageForDropDown = (messages) => {
    const list = messages.map(item => {
        return { label: item.name, value: item._id, desc: item.desc, type: item.fromschema ? "builtin" : "user" }
    })
    const alphabeticallyArrangedList = list.sort(function (a, b) {
        return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
    })
    return alphabeticallyArrangedList;
}